// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root
{
    --primary-color: #0096C9;
    --secondary-color: #00468D;
    --dark-secondary-color: #001E60;
    --accent-color: #ecaa1e;
}

@keyframes fadeIn 
{
    0% { opacity: 0;
        transform : translatey(10px); }
    100% { opacity: 1;
        transform : translatey(0px); }
}

*
{
    box-sizing: border-box;
    margin : 0;
    padding : 0;
    scroll-behavior: smooth;
}

body
{
    background: var(--primary-color);
    width: 100%;
    height: 100%;
    min-height: calc(100vh);
    position: relative;
    overflow-x: hidden;
    overscroll-behavior-y: none;
    font-family: 'Poppins', sans-serif;
    max-width: 100%;
}

#header
{
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, .6),
        rgba(0, 40, 96, 0.5),
        rgba(0, 70, 141, 0.5),
        rgba(0, 60, 96, 0.99)
     );

    background-repeat : no-repeat;
    min-height: 130vh;
    max-height: 130vh;
    position: relative;
    overflow : hidden;
}

#header-title
{
    color: white;
    font-size : clamp(32px, 4.6vw, 60px);
    font-weight: 400;
    line-height: clamp(50px, 9vw, 110px);
    text-align: center;
    position: absolute;
    right: 0;
    left: 0;
    top: 15%;
    animation: fadeIn 1s;
    padding : 0px 15px;
}

#header-subtitle
{
    color: white;
    font-size : clamp(18px, 2vw, 26px);
    text-align: center;
    position : absolute;
    right: 0;
    left: 0;
    bottom : 28%;
    animation: fadeIn 1s;
    padding : 0px 15px;
}

#header-button
{
    width : 100%;
    text-align: center;
    display : flex;
    justify-content: center;
}

#get-started-button
{
    color : var(--dark-secondary-color);
    background-color : var(--accent-color);
    font-size : 25px;
    font-weight : 600;
    border-radius: 10px;
    position : absolute;
    top: 480px;
    padding : 10px 40px;
    transition : all 0.3s ease-in-out;
    animation: fadeIn 1s;
}

#get-started-button:hover
{
    color : white;
    background-color : var(--secondary-color);
    letter-spacing: 1.2px;
    box-shadow: 0 0 35px var(--dark-secondary-color);
}

#header-curve
{
    position : absolute;
    bottom : 0;
    left : 0;
    width : 100%;
}

.landing-page-container
{
    position: relative;
    padding-top : 20px;
    padding-right : 4%;
    padding-left : 4%;
    padding-bottom: clamp(70px, 8vw, 100px);
    width : 100%;
}

.landing-page-container-title
{
    color: white;
    margin-bottom: clamp(25px, 4vw, 60px);
    font-size: clamp(24px, 3vw, 40px);
    text-align: center;
    width: 100%;
}

#landing-page-categories
{
    display : flex;
    justify-content: center;
}

.landing-page-category-box  
{
    position : relative;
    background-size: cover;
    width : 100%;
    margin: 0% 2% 0% 2%;
    overflow : hidden;
    border-radius : 10px;
    cursor: pointer;
    transition: 300ms ease ;
    color : white;
    text-align: center;
    font-weight : 500;
    font-size: 2.5vw;
    text-shadow: 2px 1px 8px rgb(0 0 0 / 100%);
}

.landing-page-category-box:hover 
{
    transform: scale(1.05);
}

.landing-page-category-title-top
{
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top : 6%;
}

.landing-page-category-title-bottom
{
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    bottom : 8%;
}

.landing-page-category-coming-soon
{
    color : white;
    text-align: center;
    font-weight : 600;
    font-size: 2.5vw;
    background-color: var(--secondary-color);
    position: absolute;
    top : 8%;
    width : 100%;
}

#schools-container
{
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-flow: wrap;
    background-color: var(--secondary-color);
    padding-top : clamp(30px, 8%, 60px);
}

#landing-page-schools-header-title
{
    margin-bottom: clamp(25px, 5vw, 70px);
}

.landing-page-school-box 
{
    color: white;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
    border-radius: 25px;
    margin: 0px 25px 50px 25px;
    width: 15%;
}

.landing-page-school-title 
{
    display: block;
    padding: 10px 10px 0px 10px;
    letter-spacing: 1.2px;
    font-size: clamp(11px, 1vw, 14px);
}

.landing-page-school-box i
{
    transition: 200ms ease;
    position: relative;
}

.landing-page-school-box:hover i
{
    color: var(--accent-color);
    scale: 1.1;
}

.landing-page-school-box:hover .landing-page-school-underline
{
    border-top: 2.5px solid var(--accent-color);
    width: 100px;
}

.landing-page-school-underline
{
    border-top: 2.5px solid white;
    width: 80px;
    transition: 200ms ease;
    margin-top: 12px;
}

#tutoring-container
{
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-flow: wrap;
    padding-top: clamp(30px, 8%, 60px);
}

#partners-container
{
    padding-top : clamp(30px, 8%, 60px);
    padding-bottom: clamp(90px, 10vw, 120px);
}

.landing-page-partners-images
{
    display : flex;
    justify-content: space-evenly;
    flex-flow: wrap;
    align-items: center;
}

.landing-page-partner-link
{
    display : contents;
}

#solvecc-image
{
    width : 38%;
    transition: 300ms ease ;
}

#solvecc-image:hover
{
    transform: scale(1.05);
}

#fourth-world-image
{
    width : 22%;
    transition: 300ms ease;
}

#fourth-world-image:hover
{
    transform: scale(1.05);
}

::-webkit-scrollbar
{
    height: 12px;
}

@media all and (max-width : 850px)
{
    #header-title
    {
        top : 140px;
    }

    #get-started-button
    {
        transform: scale(.9);
        top: 420px;
    }

    #landing-page-categories
    {
        justify-content: left;
        overflow: scroll;
        overflow-y: hidden;
        padding-bottom: 5%;
    }

    .landing-page-category-box
    {
        width: 200px;
        flex-shrink: 0;
        margin: 0% 4% 0% 0%;        
        font-size: clamp(20px, 4vw, 26px);
    }

    .landing-page-category-coming-soon
    {
        font-size : clamp(20px, 4vw, 26px);
    }

    .landing-page-school-box
    {
        width : 25%;
        margin: 0px 10px 30px 10px;
        font-size: 12px;
    }

    #school-last-box
    {
        display: none;
    }

    #solvecc-image
    {
        width : 40%;
    }

    #fourth-world-image
    {
        width : 30%;
    }
}

@media all and (max-width : 560px)
{
    .landing-page-school-box
    {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 11px;
    }

    .landing-page-school-title
    {
        width: 100px;
        padding: 10px 0px 0px 0px;
    }

    .landing-page-category-box
    {
        width : 180px;
        margin : 0px 8% 4% 0px;
    }

    .landing-page-school-box:hover .landing-page-school-underline
    {
        width: 90px;
    }

    #solvecc-image
    {
        width : 70%;
    }

    #fourth-world-image
    {
        width : 50%;
        margin-bottom : 20%;
        margin-top: 10px;
    }
}

@media all and (max-width : 480px)
{
    #header
    {
        min-height: 110vh;
        max-height: 110vh;
    }

    #header-subtitle
    {
        bottom: 100px;
    }

    #get-started-button
    {
        transform: scale(.8);
    }

    .landing-page-school-box
    {
        width: 24%;
        margin : 15px;
        margin-bottom: 10px;
        scale: 0.9;
    }
}

@media all and (max-width : 349px)
{
    #school-last-box
    {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;IAEI,wBAAwB;IACxB,0BAA0B;IAC1B,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;;IAEI,KAAK,UAAU;QACX,4BAA4B,EAAE;IAClC,OAAO,UAAU;QACb,2BAA2B,EAAE;AACrC;;AAEA;;IAEI,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,uBAAuB;AAC3B;;AAEA;;IAEI,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,kCAAkC;IAClC,eAAe;AACnB;;AAEA;;IAEI;;;;;;MAME;;IAEF,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,OAAO;IACP,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;IAEI,mCAAmC;IACnC,sCAAsC;IACtC,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,yCAAyC;IACzC,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,qCAAqC;IACrC,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;IACpC,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;IAEI,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;IAC1B,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,2BAA2B;IAC3B,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;IAC1B,UAAU;AACd;;AAEA;;IAEI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;;IAEI,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,kCAAkC;AACtC;;AAEA;;IAEI,mCAAmC;IACnC,wCAAwC;AAC5C;;AAEA;;IAEI,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI;;QAEI,WAAW;IACf;;IAEA;;QAEI,oBAAoB;QACpB,UAAU;IACd;;IAEA;;QAEI,qBAAqB;QACrB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;;QAEI,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,iCAAiC;IACrC;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,WAAW;QACX,0BAA0B;QAC1B,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;;QAEI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,oBAAoB;IACxB;;IAEA;;QAEI,UAAU;QACV,aAAa;QACb,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Poppins:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap\");\n\n:root\n{\n    --primary-color: #0096C9;\n    --secondary-color: #00468D;\n    --dark-secondary-color: #001E60;\n    --accent-color: #ecaa1e;\n}\n\n@keyframes fadeIn \n{\n    0% { opacity: 0;\n        transform : translatey(10px); }\n    100% { opacity: 1;\n        transform : translatey(0px); }\n}\n\n*\n{\n    box-sizing: border-box;\n    margin : 0;\n    padding : 0;\n    scroll-behavior: smooth;\n}\n\nbody\n{\n    background: var(--primary-color);\n    width: 100%;\n    height: 100%;\n    min-height: calc(100vh);\n    position: relative;\n    overflow-x: hidden;\n    overscroll-behavior-y: none;\n    font-family: 'Poppins', sans-serif;\n    max-width: 100%;\n}\n\n#header\n{\n    background: linear-gradient(\n        to bottom,\n        rgba(0, 0, 0, .6),\n        rgba(0, 40, 96, 0.5),\n        rgba(0, 70, 141, 0.5),\n        rgba(0, 60, 96, 0.99)\n     );\n\n    background-repeat : no-repeat;\n    min-height: 130vh;\n    max-height: 130vh;\n    position: relative;\n    overflow : hidden;\n}\n\n#header-title\n{\n    color: white;\n    font-size : clamp(32px, 4.6vw, 60px);\n    font-weight: 400;\n    line-height: clamp(50px, 9vw, 110px);\n    text-align: center;\n    position: absolute;\n    right: 0;\n    left: 0;\n    top: 15%;\n    animation: fadeIn 1s;\n    padding : 0px 15px;\n}\n\n#header-subtitle\n{\n    color: white;\n    font-size : clamp(18px, 2vw, 26px);\n    text-align: center;\n    position : absolute;\n    right: 0;\n    left: 0;\n    bottom : 28%;\n    animation: fadeIn 1s;\n    padding : 0px 15px;\n}\n\n#header-button\n{\n    width : 100%;\n    text-align: center;\n    display : flex;\n    justify-content: center;\n}\n\n#get-started-button\n{\n    color : var(--dark-secondary-color);\n    background-color : var(--accent-color);\n    font-size : 25px;\n    font-weight : 600;\n    border-radius: 10px;\n    position : absolute;\n    top: 480px;\n    padding : 10px 40px;\n    transition : all 0.3s ease-in-out;\n    animation: fadeIn 1s;\n}\n\n#get-started-button:hover\n{\n    color : white;\n    background-color : var(--secondary-color);\n    letter-spacing: 1.2px;\n    box-shadow: 0 0 35px var(--dark-secondary-color);\n}\n\n#header-curve\n{\n    position : absolute;\n    bottom : 0;\n    left : 0;\n    width : 100%;\n}\n\n.landing-page-container\n{\n    position: relative;\n    padding-top : 20px;\n    padding-right : 4%;\n    padding-left : 4%;\n    padding-bottom: clamp(70px, 8vw, 100px);\n    width : 100%;\n}\n\n.landing-page-container-title\n{\n    color: white;\n    margin-bottom: clamp(25px, 4vw, 60px);\n    font-size: clamp(24px, 3vw, 40px);\n    text-align: center;\n    width: 100%;\n}\n\n#landing-page-categories\n{\n    display : flex;\n    justify-content: center;\n}\n\n.landing-page-category-box  \n{\n    position : relative;\n    background-size: cover;\n    width : 100%;\n    margin: 0% 2% 0% 2%;\n    overflow : hidden;\n    border-radius : 10px;\n    cursor: pointer;\n    transition: 300ms ease ;\n    color : white;\n    text-align: center;\n    font-weight : 500;\n    font-size: 2.5vw;\n    text-shadow: 2px 1px 8px rgb(0 0 0 / 100%);\n}\n\n.landing-page-category-box:hover \n{\n    transform: scale(1.05);\n}\n\n.landing-page-category-title-top\n{\n    background-color: rgba(0, 0, 0, 0.3);\n    position: absolute;\n    top : 6%;\n}\n\n.landing-page-category-title-bottom\n{\n    background-color: rgba(0, 0, 0, 0.3);\n    position: absolute;\n    bottom : 8%;\n}\n\n.landing-page-category-coming-soon\n{\n    color : white;\n    text-align: center;\n    font-weight : 600;\n    font-size: 2.5vw;\n    background-color: var(--secondary-color);\n    position: absolute;\n    top : 8%;\n    width : 100%;\n}\n\n#schools-container\n{\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: row;\n    flex-flow: wrap;\n    background-color: var(--secondary-color);\n    padding-top : clamp(30px, 8%, 60px);\n}\n\n#landing-page-schools-header-title\n{\n    margin-bottom: clamp(25px, 5vw, 70px);\n}\n\n.landing-page-school-box \n{\n    color: white;\n    font-size: 14px;\n    text-align: center;\n    text-decoration: none;\n    border-radius: 25px;\n    margin: 0px 25px 50px 25px;\n    width: 15%;\n}\n\n.landing-page-school-title \n{\n    display: block;\n    padding: 10px 10px 0px 10px;\n    letter-spacing: 1.2px;\n    font-size: clamp(11px, 1vw, 14px);\n}\n\n.landing-page-school-box i\n{\n    transition: 200ms ease;\n    position: relative;\n}\n\n.landing-page-school-box:hover i\n{\n    color: var(--accent-color);\n    scale: 1.1;\n}\n\n.landing-page-school-box:hover .landing-page-school-underline\n{\n    border-top: 2.5px solid var(--accent-color);\n    width: 100px;\n}\n\n.landing-page-school-underline\n{\n    border-top: 2.5px solid white;\n    width: 80px;\n    transition: 200ms ease;\n    margin-top: 12px;\n}\n\n#tutoring-container\n{\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: row;\n    flex-flow: wrap;\n    padding-top: clamp(30px, 8%, 60px);\n}\n\n#partners-container\n{\n    padding-top : clamp(30px, 8%, 60px);\n    padding-bottom: clamp(90px, 10vw, 120px);\n}\n\n.landing-page-partners-images\n{\n    display : flex;\n    justify-content: space-evenly;\n    flex-flow: wrap;\n    align-items: center;\n}\n\n.landing-page-partner-link\n{\n    display : contents;\n}\n\n#solvecc-image\n{\n    width : 38%;\n    transition: 300ms ease ;\n}\n\n#solvecc-image:hover\n{\n    transform: scale(1.05);\n}\n\n#fourth-world-image\n{\n    width : 22%;\n    transition: 300ms ease;\n}\n\n#fourth-world-image:hover\n{\n    transform: scale(1.05);\n}\n\n::-webkit-scrollbar\n{\n    height: 12px;\n}\n\n@media all and (max-width : 850px)\n{\n    #header-title\n    {\n        top : 140px;\n    }\n\n    #get-started-button\n    {\n        transform: scale(.9);\n        top: 420px;\n    }\n\n    #landing-page-categories\n    {\n        justify-content: left;\n        overflow: scroll;\n        overflow-y: hidden;\n        padding-bottom: 5%;\n    }\n\n    .landing-page-category-box\n    {\n        width: 200px;\n        flex-shrink: 0;\n        margin: 0% 4% 0% 0%;        \n        font-size: clamp(20px, 4vw, 26px);\n    }\n\n    .landing-page-category-coming-soon\n    {\n        font-size : clamp(20px, 4vw, 26px);\n    }\n\n    .landing-page-school-box\n    {\n        width : 25%;\n        margin: 0px 10px 30px 10px;\n        font-size: 12px;\n    }\n\n    #school-last-box\n    {\n        display: none;\n    }\n\n    #solvecc-image\n    {\n        width : 40%;\n    }\n\n    #fourth-world-image\n    {\n        width : 30%;\n    }\n}\n\n@media all and (max-width : 560px)\n{\n    .landing-page-school-box\n    {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        font-size: 11px;\n    }\n\n    .landing-page-school-title\n    {\n        width: 100px;\n        padding: 10px 0px 0px 0px;\n    }\n\n    .landing-page-category-box\n    {\n        width : 180px;\n        margin : 0px 8% 4% 0px;\n    }\n\n    .landing-page-school-box:hover .landing-page-school-underline\n    {\n        width: 90px;\n    }\n\n    #solvecc-image\n    {\n        width : 70%;\n    }\n\n    #fourth-world-image\n    {\n        width : 50%;\n        margin-bottom : 20%;\n        margin-top: 10px;\n    }\n}\n\n@media all and (max-width : 480px)\n{\n    #header\n    {\n        min-height: 110vh;\n        max-height: 110vh;\n    }\n\n    #header-subtitle\n    {\n        bottom: 100px;\n    }\n\n    #get-started-button\n    {\n        transform: scale(.8);\n    }\n\n    .landing-page-school-box\n    {\n        width: 24%;\n        margin : 15px;\n        margin-bottom: 10px;\n        scale: 0.9;\n    }\n}\n\n@media all and (max-width : 349px)\n{\n    #school-last-box\n    {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
